<template>
    <div class="lead-switch d-flex align-items-center">
        <slot name="pre-label"></slot>
        <input
            type="checkbox"
            class="switch visually-hidden is-rounded"
            role="switch"
            :id="inputId"
            :aria-describedby="describedBy"
            :disabled="disabled"
            :checked="value"
            @change="$emit('input', $event.target.checked)" />
        <label :for="inputId" class="form-label m-2 toggle-input-label" v-tooltip="tooltip"></label>
        <slot name="post-label"></slot>
    </div>
</template>

<script>
export default {
    name: "ToggleInput",
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        inputId: {
            type: String,
            required: false,
            default() {
                return Math.random().toString(20).substring(2);
            },
        },
        describedBy: {
            type: String,
            default: undefined,
        },
        tooltip: {
            type: [Object, String],
            required: false,
            default: undefined,
        },
    },
};
</script>

<style scoped>
.toggle-input-label { min-height: 44px; }
.switch:focus-visible + label::before { outline: 2px solid var(--main-color-light); outline-offset: 3px; }
</style>
